module.exports = __webpack_public_path__ + "static/media/aquarider-10222_02.d2365550.png";